import { generateHeadersAuth, generateHeadersCfTns } from "../auth/authFunctions"
import { apiAnagrafeGW, apiAnagrafePub, apiAnagrafeTS } from "./api"


export const ricercaIscrizioneApiTS = async () => {
    return await apiAnagrafeTS.get("ricercaIscrizione/assistito", {
        headers: generateHeadersCfTns()
    })
}

export const ricercaIscrizioneApiSPID = async () => {
    return await apiAnagrafeGW.get("/RicercaIscrizione/assistitojwt/cf")
}

export const ricercaComuniApiTS = async (aslId) => {
    return await apiAnagrafePub.get("/RicercaComuniAsl/" + aslId, { headers: generateHeadersAuth() })
}

export const ricercaComuniApiSPID = async (aslId) => {
    return await apiAnagrafeGW.get("/RicercaComuniAsl/" + aslId)
}